
import { defineComponent, onBeforeMount, reactive } from 'vue'

// components
import PageTitle from '@/common/components/UI/PageTitle/index.vue'
import List from '@/common/components/UI/List/index.vue'
import FailedFetch from '@/common/components/UI/FailedFetch/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

// module components
import CreateVacancyForm from '@/modules/VacanciesList/components/CreateVacancyForm/index.vue'
import VacancyListItem from '@/modules/VacanciesList/components/VacancyListItem/index.vue'

// realisations
import { vacancies } from '@/core/realisations/vacancies.realisation'

// types
import { VacanciesCreateVacancyPayloadT, VacanciesVacancyT } from '@/core/types/vacancies.types'

// composable
import usePagination from '@/common/composable/usePagination'
import useCatchError from '@/common/composable/useCatchError'

export default defineComponent({
    components: {
        'page-title': PageTitle,
        list: List,
        'failed-fetch': FailedFetch,
        'the-button': TheButton,
        // 'vacancies-list-filters': VacanciesListFilters,
        'create-vacancy-form': CreateVacancyForm,
        'vacancy-list-item': VacancyListItem,
    },
    setup() {
        const state = reactive({
            is_loading: false,
            is_failed: false,
            is_add_mode: false,
            is_add_loading: false,
            vacancies: [] as VacanciesVacancyT[],
        })

        const { error_state, catchError } = useCatchError()
        const { pagination_state } = usePagination()

        const loadVacancies = async (page: number) => {
            pagination_state.current_page = page

            try {
                state.is_loading = true
                const data = await vacancies.getList(page)

                state.vacancies = data.data
                pagination_state.total_pages = data.meta.last_page
                pagination_state.total_items = data.meta.total

                state.is_failed = false
                error_state.is_cancel = false
            } catch (error) {
                catchError(error)

                if (!error_state.is_cancel) {
                    state.is_failed = true
                }
            } finally {
                if (!error_state.is_cancel) {
                    state.is_loading = false
                }
            }
        }

        onBeforeMount(() => {
            loadVacancies(1)
        })

        const createVacancy = async (vacancy_payload: VacanciesCreateVacancyPayloadT) => {
            try {
                state.is_add_loading = true

                const response = await vacancies.createVacancy(vacancy_payload)
                state.vacancies.push(response.data)

                state.is_add_mode = false
            } catch (error) {
                console.error(error)
                // TODO notification
            } finally {
                state.is_add_loading = false
            }
        }

        return {
            state,
            error_state,
            loadVacancies,
            pagination_state,
            createVacancy,
        }
    },
})
